<div class="grid">
  <div class="col-12">
    <div class="p-field mb-4">
      <label>
        {{ "COMMON.METADATA.NAME" | translate }}
      </label>
      <div class="p-fluid">
        <input [(ngModel)]="metadata.name" pInputText pSize="small" fluid />
        <small
          id="error-metadata-name"
          class="p-error"
          *ngIf="this.errors.name"
          >{{ this.errors.name }}</small
        >
      </div>
    </div>
    <div class="p-field mb-4">
      <label>{{ "COMMON.METADATA.TEXT.DEFAULT" | translate }}</label>
      <div class="p-fluid">
        <input pInputText [(ngModel)]="metadata.default" pSize="small" fluid />
        <small
          id="error-metadata-email"
          class="p-error"
          *ngIf="this.errors.default"
        >
          {{ this.errors.default }}
        </small>
      </div>
    </div>
    <div class="p-field mb-4">
      <button
        pButton
        label="{{ 'COMMON.SAVE' | translate }}"
        (click)="this.save()"
        icon="fas fa-save"
        class="virtualcenter-button virtualcenter-button--primary"
        size="small"
      ></button>
    </div>
  </div>
</div>
